import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import get from 'lodash/get'
import { AiFillApple } from 'react-icons/ai';
import {AiFillAndroid} from 'react-icons/ai'
import {
    selectNotificationStats
} from "../../../../Containers/Notifications/notificationSelectors";
import {useSelector} from "react-redux";
import {Tooltip} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(1),
        overflowX: 'auto',
        width: '100%',
    },
    table: {
        border: 'none',
        boxShadow: 'none',
        minWidth: 300,
        '& th' :{
            position:'relative',
            '& svg': {
                cursor:'pointer',
                position:'absolute',
                top:'15px',
                right: '3px'
            }
        },
        '& th, & td': {
            paddingRight: '16px',
            textAlign: 'center',
        },
    },
}));

export default function StatsTable( ) {
    const classes = useStyles();
    const stats = useSelector(selectNotificationStats)
    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell align="right">Platform</TableCell>
                    <TableCell align="right">Sent
                        <Tooltip placement="top-start" title={" The total amount of sent push notifications. This number is updated every few minutes."}>
                            <InfoIcon color="action" />
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">Direct Open
                        <Tooltip placement="top-start" title={"The total number of users who opened your app by swiping (iOS) / tapping (Android) on the notification or clicking on desktop for web push notifications."}>
                            <InfoIcon color="action" />
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">Errors</TableCell>
                    <TableCell align="right">Influenced Open
                        <Tooltip placement="top-start" title={"Total number of users who received a notification and opened your app within 3 hours."}>
                            <InfoIcon color="action" />
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">Reengaged
                        <Tooltip placement="top-start" title={"Dormant users who received a notification, opened it and then came back to the app/website in the 3 days following the notification reception."}>
                            <InfoIcon color="action" />
                        </Tooltip>
                    </TableCell>

                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="right"><AiFillApple/></TableCell>
                    <TableCell align="right">{get(stats, 'ios.detail[0].sent', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'ios.detail[0].direct_open', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'ios.detail[0].errors', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'ios.detail[0].influenced_open', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'ios.detail[0].reengaged', 0)}</TableCell>

                </TableRow>
                <TableRow>
                    <TableCell align="right"><AiFillAndroid/></TableCell>
                    <TableCell align="right">{get(stats, 'android.detail[0].sent', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'android.detail[0].direct_open', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'android.detail[0].errors', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'android.detail[0].influenced_open', 0)}</TableCell>
                    <TableCell align="right">{get(stats, 'android.detail[0].reengaged', 0)}</TableCell>

                </TableRow>
            </TableBody>
        </Table>
    );
}
